<template>
  <div
    class="confirmation"
    :class="{
      'confirmation--offline': offline,
    }"
  >
    <div class="confirmation__icon-wrapper">
      <img :src="icon" class="confirmation__icon" />
    </div>
    <h1 class="confirmation__title">
      {{ title }}
    </h1>
    <p class="confirmation__description">
      {{ description }}
    </p>
  </div>
</template>

<script>
// Icons
import { mailOpen } from 'homeday-assets/L';

export default {
  name: 'ConfirmationSlide',
  computed: {
    offline() {
      return this.$store.state.offline;
    },
    icon() {
      return mailOpen;
    },
    title() {
      return this.offline
        ? this.$t('WIZARD.CONFIRMATION.OFFLINE.TITLE')
        : this.$t('WIZARD.CONFIRMATION.ONLINE.TITLE');
    },
    description() {
      return this.offline
        ? this.$t('WIZARD.CONFIRMATION.OFFLINE.DESCRIPTION')
        : this.$t('WIZARD.CONFIRMATION.ONLINE.DESCRIPTION');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/mixins.scss';

$icon-wrapper-size: 156px;

.page__main--confirmationSlide {
  position: relative;
  background-color: getShade($quaternary-color, 40);

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    background-color: white;
    height: $icon-wrapper-size;
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

$icon-wrapper-size: 156px;
$padding-top: $sp-l;

.confirmation {
  $root: &;
  text-align: center;

  &__icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: $icon-wrapper-size;
    height: $icon-wrapper-size;
    background-color: white;
    border-radius: 50%;
    animation: glowSuccess 0.3s 0.5s forwards;

    #{$root}--offline & {
      animation-name: glowOffline;
    }
  }

  &__icon {
    width: 80%;
    height: 80%;
  }

  &__title {
    margin-top: $sp-xl;
  }
  &__description {
    margin-top: $sp-l;
  }
}

@keyframes glowSuccess {
  to {
    box-shadow: 0 0 0 12px $success-color;
  }
}

@keyframes glowOffline {
  to {
    box-shadow: 0 0 0 12px $tertiary-color;
  }
}
</style>
